export default "__VITE_ASSET__BWFLcGQk__"